<template>
  <div class="min-w-[320px] p-4">
    <Loading v-if="isLoading" class="p-8">
      <p class="text-base text-gray-800">Creating preview link...</p>
    </Loading>
    <PreviewLinkBox v-else-if="link" :link="link" :expiresAt="expiresAt" />
    <p v-else class="text-base text-gray-800">Could not create a preview link.</p>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { sharePrettyPreviewApi } from "@/api/previewRequests";
import Loading from "@/components/UI/Loading/Loading.vue";
import PreviewLinkBox from "@/components/Previews/PreviewLinkBox/PreviewLinkBox.vue";
import { canvasPreviewLink } from "@/utils/canvasPreviewLink";

const props = defineProps({
  id: {
    type: [String, Number],
    required: true,
  },
  // Called with the new share state — { hash, expires_at, expired } — so whoever opened
  // the modal can show the fresh link.
  onShared: {
    type: Function,
    default: () => {},
  },
});

const isLoading = ref(true);
const link = ref(null);
const expiresAt = ref("");

onMounted(async () => {
  try {
    const { data } = await sharePrettyPreviewApi(props.id);
    link.value = canvasPreviewLink(data.hash);
    expiresAt.value = data.expires_at || "";
    props.onShared(data);
  } catch (error) {
    // The request layer has already toasted the server's message.
    link.value = null;
  } finally {
    isLoading.value = false;
  }
});
</script>
